import { configure } from '@js-boot/logger';
import { LogLevelDesc } from 'loglevel';

const { getLogger, getDefaultLogger } = configure({
  level: (process.env.LOG_LEVEL as LogLevelDesc) ?? 'info',
  http: process.env.LOG_HTTP_SINK ? { url: process.env.LOG_HTTP_SINK } : undefined,
});

export { getLogger, getDefaultLogger };
